import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('ControlGroupItem', null, { withChildren: true });
